import { render } from "./materialLibrary.vue?vue&type=template&id=4fefeac8&scoped=true"
import script from "./materialLibrary.vue?vue&type=script&lang=js"
export * from "./materialLibrary.vue?vue&type=script&lang=js"

import "./materialLibrary.vue?vue&type=style&index=0&id=4fefeac8&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fefeac8"]])

export default __exports__